import { useNavigate, useLocation } from 'react-router-dom';
import styles from './SideBar.module.css';

// 자신 또는 하위 메뉴의 path가 현재 경로와 일치하면 선택 상태(주황색)
const MENU = [
	{ label: 'Home', path: '/' },
	{ label: 'Dashboard' },
	{ label: 'Product', children: [
		{ label: 'Review Collection & Analysis', path: '/reviews', multiline: true },
	] },
	{ label: 'Marketing', children: [
		{ label: 'Top Chart', children: [
			{ label: 'Contents', path: '/contents' },
			{ label: 'Music', path: '/music' },
			{ label: 'Creators', path: '/creators' },
			{ label: 'Comments' },
		] },
		{ label: 'Search', children: [
			{ label: 'Creators' },
			{ label: 'Audience' },
		] },
	] },
];

const LEVEL_CLASS = [
	styles.menuItem,
	styles.menuItemSub,
	`${styles.menuItemSub} ${styles.menuItemSubSub}`,
];

const isActive = (item, pathname) =>
	item.path === pathname || (item.children ?? []).some((child) => isActive(child, pathname));

const SideBar = () => {
	const navigate = useNavigate();
	const location = useLocation();

	const renderItems = (items, depth, keyPrefix = '') => items.flatMap((item) => {
		const key = `${keyPrefix}/${item.label}`;
		const className = [
			LEVEL_CLASS[depth],
			item.multiline && styles.menuItemMultiline,
			item.path && styles.clickable,
			isActive(item, location.pathname) && styles.menuItemActive,
		].filter(Boolean).join(' ');
		return [
			<div
				key={key}
				className={className}
				onClick={item.path && (() => navigate(item.path))}
			>
				<div className={styles.menuItemContent}>
					<div className={styles.menuItemText}>
						{depth === 0
							? <b className={styles.menuItemTextBold}>{item.label}</b>
							: <div className={styles.menuItemTextNormal}>{item.label}</div>}
					</div>
				</div>
			</div>,
			...renderItems(item.children ?? [], depth + 1, key),
		];
	});

	return (
		<div className={styles.sideBarContainer}>
			<div className={styles.sideBarContent}>
				{renderItems(MENU, 0)}
			</div>
		</div>
	);
};

export default SideBar;
